import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemBeetrootSeeds extends Item {
    constructor() {
        super(definitions.ITEM_ID.BEETROOT_SEEDS, texture("prop_beetroot_seeds_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.MEDIUM, 0.6, new PIXI.Point(0, 0));
    }
}